import axios from "axios";
import API from './api';
import AES from "@/utils/AES.js";

const payService = {
    precreate(userInfo, examId, phone, targetScore, maxScore, targetExamTime, maxExamTime, groupTitle, examTitle, groupImg, userId, groupId, inviteCode, yibanID, userToken, tel, password) {
        return new Promise((resolve, reject) => {
            let data = AES.encrypt(
                JSON.stringify({
                    userInfo,
                    examId,
                    phone,
                    targetScore,
                    maxScore,
                    targetExamTime,
                    maxExamTime,
                    groupId,
                    groupTitle,
                    examTitle,
                    groupImg,
                    userId,
                    inviteCode,
                    yibanID,
                    userToken,
                    tel,
                    password
                })
            );
            axios.post(`${API.localhost}/v1/order/subOrder`, {
                data
            }).then(res => {
                resolve(res.data);
            }).catch(err => {
                reject(err);
            })
        });
    },
    query(orderId, isInfo, AuthorizationCode) {
        return new Promise((resolve, reject) => {
            axios({
                method: 'GET',
                url: `${API.localhost}/v1/order/queryOrder`,
                params: {
                    orderId,
                    isInfo,
                    AuthorizationCode
                }
            }).then(res => {
                resolve(res.data);
            }).catch(err => {
                reject(err);
            });
        })
    },
    save(orderId, orderObject, AuthorizationCode) {
        return new Promise((resolve, reject) => {
            axios({
                method: 'POST',
                url: `${API.localhost}/v1/order/SaveOrder`,
                data: { orderObject: JSON.stringify(orderObject) },
                params: {
                    orderId, AuthorizationCode
                },
            }).then(res => {
                resolve(res);
            }).catch(err => {
                reject(err);
            });
        })
    },
    verifyPhone(orderId, phone) {
        return new Promise((resolve, reject) => {
            axios({
                method: 'POST',
                url: `${API.localhost}/v1/order/VerifyPhone`,
                data: {
                    orderId, phone
                }
            }).then(res => {
                resolve(res);
            }).catch(err => {
                reject(err);
            });
        })
    },
    modifyOrder(orderId, phone, targetExamTime, targetScore) {
        console.log(orderId, phone, targetExamTime, targetScore);
        return new Promise((resolve, reject) => {
            axios({
                method: 'POST',
                url: `${API.localhost}/v1/order/ModifyOrder`,
                data: {
                    orderId, phone, targetExamTime, targetScore
                }
            }).then(res => {
                resolve(res);
            }).catch(err => {
                reject(err);
            });
        })
    }
}

export { payService }